module.exports = __webpack_public_path__ + "img/Chart.1f731c61.svg";